"use client";
import SignatureCanvas from "react-signature-canvas";
import { useRef, useState } from "react";
import "react-phone-input-2/lib/style.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";
import { az } from "date-fns/locale";
import Link from "next/link";
import X from "@/public/icon/x.svg";
import Success from "@/public/icon/success.svg";
import Error from "@/public/icon/error.svg";
import http from "@/libs/config/http";
import Logo from "@/public/icon/logo.svg";
import Cloud1 from "@/public/images/cloud1.png";
import Cloud2 from "@/public/images/cloud2.png";
import Circle from "@/public/images/circle.png";
import Circle2 from "@/public/images/circle2.png";
import Rainbow from "@/public/images/rainbow.png";
import Circle3 from "@/public/images/circle3.png";
import Circle4 from "@/public/images/circle4.png";
import Boy from "@/public/images/boy.svg";
import Girl from "@/public/images/girl.svg";
import Star from "@/public/images/star2.png";
import Rocket from "@/public/images/rocket.png";
import Star1 from "@/public/images/star1.png";
import Image from "next/image";
import Lang from "@/components/Lang/Lang";
import Sweet from "@/public/icon/sweet.svg";
import Bong from "@/public/icon/bong.svg";
import Builder from "@/public/icon/builder.svg";
import Motor from "@/public/icon/motor.svg";
import Kids from "@/public/icon/kids_club.svg";
import Succ from "@/public/icon/succ.svg";
import Arrow from "@/public/icon/arrow.svg";
import Delete from "@/public/icon/delete.png";
import { motion, AnimatePresence } from "framer-motion";
const CATEGORY_MAP = {
  sweet: "sweet_city",
  bong: "bono_bourg",
  builder: "builder_city",
  motor: "motor_city",
  kids_club: "kids_club",
};

const Form = ({ t }) => {
  const allowedPrefixes = ["994", "7", "090"];
  const [activeTab, setActiveTab] = useState("sweet");
  const [selectedDate, setSelectedDate] = useState(null);
  const [isChecked, setIsChecked] = useState(false);
  const [isSignatureConfirmed, setIsSignatureConfirmed] = useState(false);
  const [status, setStatus] = useState("");
  const [isInView, setIsInView] = useState(false);
  const [signature, setSignature] = useState(null);

  const sigCanvas = useRef(null);
  const saveSignature = () => {
    const dataURL = sigCanvas.current.getCanvas().toDataURL("image/png");

    setFormData((prev) => ({
      ...prev,
      signature: dataURL,
    }));

    setIsSignatureConfirmed(true);
  };

  const [formData, setFormData] = useState({
    full_name: "",
    phone: "",
    identity_card: "",
    countryCode: "994",
    address: "",
    date: "",
    agree: false,
    signature: "",
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));

    if (name === "agree") setIsChecked(checked);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("Sending");

    try {
      const form = new FormData();

      form.append("category", CATEGORY_MAP[activeTab]);
      form.append("full_name", formData.full_name);
      form.append("address", formData.address);
      form.append("phone", formData.phone);
      form.append("countryCode", `+${formData.countryCode}`);
      form.append("date", formData.date);
      form.append("agree", formData.agree ? 1 : 0);
      form.append("signature", formData.signature);

      const response = await http("register", {
        method: "POST",
        body: form,
      });

      if (response === "success") {
        setStatus("success");
        setIsInView(true);

        setFormData({
          full_name: "",
          phone: "",
          address: "",
          countryCode: "994",
          date: "",
          agree: false,
          signature: "",
        });

        sigCanvas.current.clear();
        setIsSignatureConfirmed(false);
      } else {
        setStatus("failed");
        setIsInView(true);
      }
    } catch (error) {
      console.error(error);
      setStatus("error");
      setIsInView(true);
    }
  };
  const closeButton = () => {
    setIsInView(false);
  };
  // tab

  return (
    <div>
      <div className={` ${isInView ? "active " : ""} popup`}>
        {status == "success" ? (
          <div className="popupInner">
            <div className="close" onClick={() => closeButton()}>
              <X />
            </div>
            <div className="popupInnerSuccess">
              <div>
                <span>{t?.[`sorğunuz qəbul oldu!`]}</span>
                <p>{t?.[`Tezliklə sizə geri dönüş ediləcək`]}</p>
              </div>
              <Success />
            </div>
          </div>
        ) : (
          <div className="popupInner">
            <div className="close" onClick={() => closeButton()}>
              <X />
            </div>
            <div className="popupInnerError">
              <div>
                <span>{t?.[`Yenİdən cəhd edİn !`]}</span>
                <p>{t?.[`Sorgunuz qəbul olmadı`]}</p>
              </div>
              <Error />
            </div>
          </div>
        )}
      </div>
      <div className="page">
        <Image src={Cloud1} alt="cloud" className="cloud1" />
        <Image src={Cloud2} alt="cloud" className="cloud2" />
        <Image src={Circle} alt="cloud" className="circle" />
        <Image src={Star} alt="cloud" className="star" />
        <Image src={Star1} alt="cloud" className="star1" />
        <Image src={Circle2} alt="cloud" className="circle2" />
        <Image src={Circle3} alt="cloud" className="circle3" />
        <Image src={Circle4} alt="cloud" className="circle4" />
        <Image src={Rocket} alt="rocket" className="rocket" />

        <div className="logo">
          <Logo />
          <Lang />
        </div>
        <div className="tabTop">
          <button
            onClick={() => setActiveTab("sweet")}
            className={`tab ${activeTab === "sweet" ? "active" : ""}`}
          >
            <motion.div
              animate={activeTab === "sweet" ? { scale: 1.2 } : { scale: 1 }}
              transition={{ duration: 0.3 }}
            >
              <Sweet />
            </motion.div>
          </button>
          <button
            onClick={() => setActiveTab("bong")}
            className={`tab ${activeTab === "bong" ? "active" : ""}`}
          >
            <motion.div
              animate={activeTab === "bong" ? { scale: 1.2 } : { scale: 1 }}
              transition={{ duration: 0.3 }}
            >
              <Bong />
            </motion.div>
          </button>
          <button
            onClick={() => setActiveTab("builder")}
            className={`tab ${activeTab === "builder" ? "active" : ""}`}
          >
            <motion.div
              animate={activeTab === "builder" ? { scale: 1.2 } : { scale: 1 }}
              transition={{ duration: 0.3 }}
            >
              <Builder />
            </motion.div>
          </button>
          <button
            onClick={() => setActiveTab("motor")}
            className={`tab ${activeTab === "motor" ? "active" : ""}`}
          >
            <motion.div
              animate={activeTab === "motor" ? { scale: 1.2 } : { scale: 1 }}
              transition={{ duration: 0.3 }}
            >
              <Motor />
            </motion.div>
          </button>
          <button
            onClick={() => setActiveTab("kids_club")}
            className={`tab ${activeTab === "kids_club" ? "active" : ""}`}
          >
            <motion.div
              animate={
                activeTab === "kids_club" ? { scale: 1.2 } : { scale: 1 }
              }
              transition={{ duration: 0.3 }}
            >
              <Kids />
            </motion.div>
          </button>
        </div>
        <div className="formSection">
          <div className="formTab">
            <div className="formTabInner">
              <h1> {t?.[`Müraciət formu`]}</h1>
              <p>{t?.[`Yalnız böyüklər üçün keçərlidir`]}</p>
              <AnimatePresence mode="wait">
                {activeTab === "sweet" && (
                  <motion.div
                    key="sweet"
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -30 }}
                    transition={{ duration: 0.4, ease: "easeInOut" }}
                  >
                    <form action="" onSubmit={handleSubmit}>
                      <input
                        type="hidden"
                        name="category"
                        value={CATEGORY_MAP[activeTab]}
                      />

                      <div className="inputChild">
                        <label htmlFor="">{t?.[`Ad/ soyad`]}</label>
                        <input
                          type="text"
                          name="full_name"
                          value={formData.full_name}
                          onChange={handleChange}
                          required
                          placeholder={t?.[`Ad/ soyad`]}
                        />
                      </div>

                      <div className="inputChild phoneChild">
                        <label htmlFor="">{t?.[`Telefon`]}</label>
                        <div>
                          <select
                            name="countryCode"
                            value={formData.countryCode}
                            onChange={handleChange}
                          >
                            {allowedPrefixes.map((pfx) => (
                              <option key={pfx} value={pfx}>
                                {pfx}
                              </option>
                            ))}
                          </select>

                          <input
                            type="number"
                            name="phone"
                            value={formData.phone}
                            onChange={handleChange}
                            required
                            placeholder={t?.[`Telefon`]}
                          />
                        </div>
                      </div>
                      <div className="inputChild">
                        <label htmlFor="">{t?.[`Ünvan`]}</label>
                        <input
                          type="text"
                          name="address"
                          value={formData.address}
                          onChange={handleChange}
                          // required
                          placeholder={t?.[`Ünvan`]}
                        />
                      </div>
                      <div className="inputChild dateChild">
                        <label htmlFor="">{t?.[`Tarİx`]}</label>
                        <DatePicker
                          selected={selectedDate}
                          dateFormat="MMMM/dd/yyyy"
                          locale={az}
                          minDate={new Date()}
                          placeholderText={t?.[`Tarix seçin`]}
                          required
                          onChange={(date) => {
                            setSelectedDate(date);
                            setFormData((prevData) => ({
                              ...prevData,
                              date: format(date, "MMMM/dd/yyyy"),
                            }));
                          }}
                        />
                      </div>

                      <label className="checkbox-parent">
                        <p>
                          <Link
                            href={`/terms/${CATEGORY_MAP[activeTab]}`}
                            className="termsLink"
                          >
                            {t?.[`Qaydalar və şərtlər`]}
                          </Link>
                          {
                            t?.[
                              `Qeyd olunan qaydalarla tanış oldum və təsdiq edirəm.`
                            ]
                          }
                        </p>
                        <input
                          type="checkbox"
                          name="agree"
                          checked={formData.agree}
                          onChange={handleChange}
                        />
                        <span className="checkmark"></span>
                      </label>
                      <div className="signature">
                        <div className="inputChild">
                          <label>{t?.[`İmza`]}</label>
                          <div className="signatureButtons">
                            <SignatureCanvas
                              ref={sigCanvas}
                              canvasProps={{ className: "border" }}
                            />
                            <button
                              type="button"
                              className="deleteButton"
                              onClick={() => {
                                sigCanvas.current.clear();
                                setSignature(null);
                                setFormData((prevData) => ({
                                  ...prevData,
                                  signature: "",
                                }));
                              }}
                            >
                              <Image src={Delete} alt="cloud" />

                              {t?.[`imzanı sil`]}
                            </button>
                            <button
                              type="button"
                              onClick={() => {
                                saveSignature();
                                setIsSignatureConfirmed(true);
                              }}
                              className="successButton"
                            >
                              <Succ />
                              {t?.[`imzanı təsdiqlə`]}
                            </button>
                            <div className="signatureStatus">
                              {isSignatureConfirmed && (
                                <span>{t?.["imzanız təsdiqləndi"]}</span>
                              )}
                            </div>
                          </div>
                        </div>

                        <p>
                          {t?.[`imzanı çəkdikdən sonra təsdiqləməyi unutmayın`]}
                        </p>
                      </div>

                      <button
                        type="submit"
                        className={`blueButton ${isChecked ? "" : " deactive"}`}
                      >
                        <span>{t?.[`göndər`]}</span>
                        <Arrow />
                      </button>
                      <Link
                        href={`/terms/${CATEGORY_MAP[activeTab]}`}
                        className="termsLink"
                      >
                        {t?.[`Qaydalar və şərtlər`]}
                      </Link>
                    </form>
                  </motion.div>
                )}
                {activeTab === "bong" && (
                  <motion.div
                    key="bong"
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -30 }}
                    transition={{ duration: 0.4, ease: "easeInOut" }}
                  >
                    <form action="" onSubmit={handleSubmit}>
                      <input
                        type="hidden"
                        name="category"
                        value={CATEGORY_MAP[activeTab]}
                      />

                      <input
                        type="hidden"
                        name="category"
                        value={CATEGORY_MAP[activeTab]}
                      />

                      <div className="inputChild">
                        <label htmlFor="">{t?.[`Ad/ soyad`]}</label>
                        <input
                          type="text"
                          name="full_name"
                          value={formData.full_name}
                          onChange={handleChange}
                          required
                          placeholder={t?.[`Ad/ soyad`]}
                        />
                      </div>

                      <div className="inputChild phoneChild">
                        <label htmlFor="">{t?.[`Telefon`]}</label>
                        <div>
                          <select
                            name="countryCode"
                            value={formData.countryCode}
                            onChange={handleChange}
                          >
                            {allowedPrefixes.map((pfx) => (
                              <option key={pfx} value={pfx}>
                                {pfx}
                              </option>
                            ))}
                          </select>

                          <input
                            type="number"
                            name="phone"
                            value={formData.phone}
                            onChange={handleChange}
                            required
                            placeholder={t?.[`Telefon`]}
                          />
                        </div>
                      </div>
                      <div className="inputChild">
                        <label htmlFor="">{t?.[`Ünvan`]}</label>
                        <input
                          type="text"
                          name="address"
                          value={formData.address}
                          onChange={handleChange}
                          // required
                          placeholder={t?.[`Ünvan`]}
                        />
                      </div>
                      <div className="inputChild dateChild">
                        <label htmlFor="">{t?.[`Tarİx`]}</label>
                        <DatePicker
                          selected={selectedDate}
                          dateFormat="MMMM/dd/yyyy"
                          locale={az}
                          minDate={new Date()}
                          placeholderText={t?.[`Tarix seçin`]}
                          required
                          onChange={(date) => {
                            setSelectedDate(date);
                            setFormData((prevData) => ({
                              ...prevData,
                              date: format(date, "MMMM/dd/yyyy"),
                            }));
                          }}
                        />
                      </div>

                      <label className="checkbox-parent">
                        <p>
                          <Link
                            href={`/terms/${CATEGORY_MAP[activeTab]}`}
                            className="termsLink"
                          >
                            {t?.[`Qaydalar və şərtlər`]}
                          </Link>
                          {
                            t?.[
                              `Qeyd olunan qaydalarla tanış oldum və təsdiq edirəm.`
                            ]
                          }
                        </p>
                        <input
                          type="checkbox"
                          name="agree"
                          checked={formData.agree}
                          onChange={handleChange}
                        />
                        <span className="checkmark"></span>
                      </label>
                      <div className="signature">
                        <div className="inputChild">
                          <label>{t?.[`İmza`]}</label>
                          <div className="signatureButtons">
                            <SignatureCanvas
                              ref={sigCanvas}
                              canvasProps={{ className: "border" }}
                            />
                            <button
                              type="button"
                              className="deleteButton"
                              onClick={() => {
                                sigCanvas.current.clear();
                                setSignature(null);
                                setFormData((prevData) => ({
                                  ...prevData,
                                  signature: "",
                                }));
                              }}
                            >
                              <Image src={Delete} alt="cloud" />

                              {t?.[`imzanı sil`]}
                            </button>
                            <button
                              type="button"
                              onClick={() => {
                                saveSignature();
                                setIsSignatureConfirmed(true);
                              }}
                              className="successButton"
                            >
                              <Succ />
                              {t?.[`imzanı təsdiqlə`]}
                            </button>
                            <div className="signatureStatus">
                              {isSignatureConfirmed && (
                                <span>{t?.["imzanız təsdiqləndi"]}</span>
                              )}
                            </div>
                          </div>
                        </div>

                        <p>
                          {t?.[`imzanı çəkdikdən sonra təsdiqləməyi unutmayın`]}
                        </p>
                      </div>

                      <button
                        type="submit"
                        className={`blueButton ${isChecked ? "" : " deactive"}`}
                      >
                        <span>{t?.[`göndər`]}</span>
                        <Arrow />
                      </button>
                      <Link
                        href={`/terms/${CATEGORY_MAP[activeTab]}`}
                        className="termsLink"
                      >
                        {t?.[`Qaydalar və şərtlər`]}
                      </Link>
                    </form>
                  </motion.div>
                )}
                {activeTab === "builder" && (
                  <motion.div
                    key="builder"
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -30 }}
                    transition={{ duration: 0.4, ease: "easeInOut" }}
                  >
                    <form action="" onSubmit={handleSubmit}>
                      <input
                        type="hidden"
                        name="category"
                        value={CATEGORY_MAP[activeTab]}
                      />

                      <div className="inputChild">
                        <label htmlFor="">{t?.[`Ad/ soyad`]}</label>
                        <input
                          type="text"
                          name="full_name"
                          value={formData.full_name}
                          onChange={handleChange}
                          required
                          placeholder={t?.[`Ad/ soyad`]}
                        />
                      </div>

                      <div className="inputChild phoneChild">
                        <label htmlFor="">{t?.[`Telefon`]}</label>
                        <div>
                          <select
                            name="countryCode"
                            value={formData.countryCode}
                            onChange={handleChange}
                          >
                            {allowedPrefixes.map((pfx) => (
                              <option key={pfx} value={pfx}>
                                {pfx}
                              </option>
                            ))}
                          </select>

                          <input
                            type="number"
                            name="phone"
                            value={formData.phone}
                            onChange={handleChange}
                            required
                            placeholder={t?.[`Telefon`]}
                          />
                        </div>
                      </div>
                      <div className="inputChild">
                        <label htmlFor="">{t?.[`Ünvan`]}</label>
                        <input
                          type="text"
                          name="address"
                          value={formData.address}
                          onChange={handleChange}
                          // required
                          placeholder={t?.[`Ünvan`]}
                        />
                      </div>
                      <div className="inputChild dateChild">
                        <label htmlFor="">{t?.[`Tarİx`]}</label>
                        <DatePicker
                          selected={selectedDate}
                          dateFormat="MMMM/dd/yyyy"
                          locale={az}
                          minDate={new Date()}
                          placeholderText={t?.[`Tarix seçin`]}
                          required
                          onChange={(date) => {
                            setSelectedDate(date);
                            setFormData((prevData) => ({
                              ...prevData,
                              date: format(date, "MMMM/dd/yyyy"),
                            }));
                          }}
                        />
                      </div>

                      <label className="checkbox-parent">
                        <p>
                          <Link
                            href={`/terms/${CATEGORY_MAP[activeTab]}`}
                            className="termsLink"
                          >
                            {t?.[`Qaydalar və şərtlər`]}
                          </Link>
                          {
                            t?.[
                              `Qeyd olunan qaydalarla tanış oldum və təsdiq edirəm.`
                            ]
                          }
                        </p>
                        <input
                          type="checkbox"
                          name="agree"
                          checked={formData.agree}
                          onChange={handleChange}
                        />
                        <span className="checkmark"></span>
                      </label>
                      <div className="signature">
                        <div className="inputChild">
                          <label>{t?.[`İmza`]}</label>
                          <div className="signatureButtons">
                            <SignatureCanvas
                              ref={sigCanvas}
                              canvasProps={{ className: "border" }}
                            />
                            <button
                              type="button"
                              className="deleteButton"
                              onClick={() => {
                                sigCanvas.current.clear();
                                setSignature(null);
                                setFormData((prevData) => ({
                                  ...prevData,
                                  signature: "",
                                }));
                              }}
                            >
                              <Image src={Delete} alt="cloud" />

                              {t?.[`imzanı sil`]}
                            </button>
                            <button
                              type="button"
                              onClick={() => {
                                saveSignature();
                                setIsSignatureConfirmed(true);
                              }}
                              className="successButton"
                            >
                              <Succ />
                              {t?.[`imzanı təsdiqlə`]}
                            </button>
                            <div className="signatureStatus">
                              {isSignatureConfirmed && (
                                <span>{t?.["imzanız təsdiqləndi"]}</span>
                              )}
                            </div>
                          </div>
                        </div>

                        <p>
                          {t?.[`imzanı çəkdikdən sonra təsdiqləməyi unutmayın`]}
                        </p>
                      </div>

                      <button
                        type="submit"
                        className={`blueButton ${isChecked ? "" : " deactive"}`}
                      >
                        <span>{t?.[`göndər`]}</span>
                        <Arrow />
                      </button>
                      <Link
                        href={`/terms/${CATEGORY_MAP[activeTab]}`}
                        className="termsLink"
                      >
                        {t?.[`Qaydalar və şərtlər`]}
                      </Link>
                    </form>
                  </motion.div>
                )}
                {activeTab === "motor" && (
                  <motion.div
                    key="motor"
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -30 }}
                    transition={{ duration: 0.4, ease: "easeInOut" }}
                  >
                    <form action="" onSubmit={handleSubmit}>
                      <input
                        type="hidden"
                        name="category"
                        value={CATEGORY_MAP[activeTab]}
                      />

                      <div className="inputChild">
                        <label htmlFor="">{t?.[`Ad/ soyad`]}</label>
                        <input
                          type="text"
                          name="full_name"
                          value={formData.full_name}
                          onChange={handleChange}
                          required
                          placeholder={t?.[`Ad/ soyad`]}
                        />
                      </div>

                      <div className="inputChild phoneChild">
                        <label htmlFor="">{t?.[`Telefon`]}</label>
                        <div>
                          <select
                            name="countryCode"
                            value={formData.countryCode}
                            onChange={handleChange}
                          >
                            {allowedPrefixes.map((pfx) => (
                              <option key={pfx} value={pfx}>
                                {pfx}
                              </option>
                            ))}
                          </select>

                          <input
                            type="number"
                            name="phone"
                            value={formData.phone}
                            onChange={handleChange}
                            required
                            placeholder={t?.[`Telefon`]}
                          />
                        </div>
                      </div>
                      <div className="inputChild">
                        <label htmlFor="">{t?.[`Ünvan`]}</label>
                        <input
                          type="text"
                          name="address"
                          value={formData.address}
                          onChange={handleChange}
                          // required
                          placeholder={t?.[`Ünvan`]}
                        />
                      </div>
                      <div className="inputChild dateChild">
                        <label htmlFor="">{t?.[`Tarİx`]}</label>
                        <DatePicker
                          selected={selectedDate}
                          dateFormat="MMMM/dd/yyyy"
                          locale={az}
                          minDate={new Date()}
                          placeholderText={t?.[`Tarix seçin`]}
                          required
                          onChange={(date) => {
                            setSelectedDate(date);
                            setFormData((prevData) => ({
                              ...prevData,
                              date: format(date, "MMMM/dd/yyyy"),
                            }));
                          }}
                        />
                      </div>

                      <label className="checkbox-parent">
                        <p>
                          <Link
                            href={`/terms/${CATEGORY_MAP[activeTab]}`}
                            className="termsLink"
                          >
                            {t?.[`Qaydalar və şərtlər`]}
                          </Link>
                          {
                            t?.[
                              `Qeyd olunan qaydalarla tanış oldum və təsdiq edirəm.`
                            ]
                          }
                        </p>
                        <input
                          type="checkbox"
                          name="agree"
                          checked={formData.agree}
                          onChange={handleChange}
                        />
                        <span className="checkmark"></span>
                      </label>
                      <div className="signature">
                        <div className="inputChild">
                          <label>{t?.[`İmza`]}</label>
                          <div className="signatureButtons">
                            <SignatureCanvas
                              ref={sigCanvas}
                              canvasProps={{ className: "border" }}
                            />
                            <button
                              type="button"
                              className="deleteButton"
                              onClick={() => {
                                sigCanvas.current.clear();
                                setSignature(null);
                                setFormData((prevData) => ({
                                  ...prevData,
                                  signature: "",
                                }));
                              }}
                            >
                              <Image src={Delete} alt="cloud" />

                              {t?.[`imzanı sil`]}
                            </button>
                            <button
                              type="button"
                              onClick={() => {
                                saveSignature();
                                setIsSignatureConfirmed(true);
                              }}
                              className="successButton"
                            >
                              <Succ />
                              {t?.[`imzanı təsdiqlə`]}
                            </button>
                            <div className="signatureStatus">
                              {isSignatureConfirmed && (
                                <span>{t?.["imzanız təsdiqləndi"]}</span>
                              )}
                            </div>
                          </div>
                        </div>

                        <p>
                          {t?.[`imzanı çəkdikdən sonra təsdiqləməyi unutmayın`]}
                        </p>
                      </div>

                      <button
                        type="submit"
                        className={`blueButton ${isChecked ? "" : " deactive"}`}
                      >
                        <span>{t?.[`göndər`]}</span>
                        <Arrow />
                      </button>
                      <Link
                        href={`/terms/${CATEGORY_MAP[activeTab]}`}
                        className="termsLink"
                      >
                        {t?.[`Qaydalar və şərtlər`]}
                      </Link>
                    </form>
                  </motion.div>
                )}
                {activeTab === "kids_club" && (
                  <motion.div
                    key="kids_club"
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -30 }}
                    transition={{ duration: 0.4, ease: "easeInOut" }}
                  >
                    <form action="" onSubmit={handleSubmit}>
                      <input
                        type="hidden"
                        name="category"
                        value={CATEGORY_MAP[activeTab]}
                      />

                      <div className="inputChild">
                        <label htmlFor="">{t?.[`Ad/ soyad`]}</label>
                        <input
                          type="text"
                          name="full_name"
                          value={formData.full_name}
                          onChange={handleChange}
                          required
                          placeholder={t?.[`Ad/ soyad`]}
                        />
                      </div>

                      <div className="inputChild phoneChild">
                        <label htmlFor="">{t?.[`Telefon`]}</label>
                        <div>
                          <select
                            name="countryCode"
                            value={formData.countryCode}
                            onChange={handleChange}
                          >
                            {allowedPrefixes.map((pfx) => (
                              <option key={pfx} value={pfx}>
                                {pfx}
                              </option>
                            ))}
                          </select>

                          <input
                            type="number"
                            name="phone"
                            value={formData.phone}
                            onChange={handleChange}
                            required
                            placeholder={t?.[`Telefon`]}
                          />
                        </div>
                      </div>
                      <div className="inputChild">
                        <label htmlFor="">{t?.[`Ünvan`]}</label>
                        <input
                          type="text"
                          name="address"
                          value={formData.address}
                          onChange={handleChange}
                          // required
                          placeholder={t?.[`Ünvan`]}
                        />
                      </div>
                      <div className="inputChild dateChild">
                        <label htmlFor="">{t?.[`Tarİx`]}</label>
                        <DatePicker
                          selected={selectedDate}
                          dateFormat="MMMM/dd/yyyy"
                          locale={az}
                          minDate={new Date()}
                          placeholderText={t?.[`Tarix seçin`]}
                          required
                          onChange={(date) => {
                            setSelectedDate(date);
                            setFormData((prevData) => ({
                              ...prevData,
                              date: format(date, "MMMM/dd/yyyy"),
                            }));
                          }}
                        />
                      </div>

                      <label className="checkbox-parent">
                        <p>
                          <Link
                            href={`/terms/${CATEGORY_MAP[activeTab]}`}
                            className="termsLink"
                          >
                            {t?.[`Qaydalar və şərtlər`]}
                          </Link>
                          {
                            t?.[
                              `Qeyd olunan qaydalarla tanış oldum və təsdiq edirəm.`
                            ]
                          }
                        </p>
                        <input
                          type="checkbox"
                          name="agree"
                          checked={formData.agree}
                          onChange={handleChange}
                        />
                        <span className="checkmark"></span>
                      </label>
                      <div className="signature">
                        <div className="inputChild">
                          <label>{t?.[`İmza`]}</label>
                          <div className="signatureButtons">
                            <SignatureCanvas
                              ref={sigCanvas}
                              canvasProps={{ className: "border" }}
                            />
                            <button
                              type="button"
                              className="deleteButton"
                              onClick={() => {
                                sigCanvas.current.clear();
                                setSignature(null);
                                setFormData((prevData) => ({
                                  ...prevData,
                                  signature: "",
                                }));
                              }}
                            >
                              <Image src={Delete} alt="cloud" />

                              {t?.[`imzanı sil`]}
                            </button>
                            <button
                              type="button"
                              onClick={() => {
                                saveSignature();
                                setIsSignatureConfirmed(true);
                              }}
                              className="successButton"
                            >
                              <Succ />
                              {t?.[`imzanı təsdiqlə`]}
                            </button>
                            <div className="signatureStatus">
                              {isSignatureConfirmed && (
                                <span>{t?.["imzanız təsdiqləndi"]}</span>
                              )}
                            </div>
                          </div>
                        </div>

                        <p>
                          {t?.[`imzanı çəkdikdən sonra təsdiqləməyi unutmayın`]}
                        </p>
                      </div>

                      <button
                        type="submit"
                        className={`blueButton ${isChecked ? "" : " deactive"}`}
                      >
                        <span>{t?.[`göndər`]}</span>
                        <Arrow />
                      </button>
                      <Link
                        href={`/terms/${CATEGORY_MAP[activeTab]}`}
                        className="termsLink"
                      >
                        {t?.[`Qaydalar və şərtlər`]}
                      </Link>
                    </form>
                  </motion.div>
                )}
              </AnimatePresence>
              <Boy className="boy" />
              <Image src={Rainbow} alt="rainbow" className="rainbow" />
              <Girl className="girl" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Form;
